export const getProducts = `
  query getProducts {
    products {
      value: productUuid
      label: name
    }
  }
`;

export interface ProductOption {
  value: string;
  label: string;
}

export interface GetProductsType {
  products: ProductOption[];
}
